import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dsp-selector"
//
// Writes the ticked checkbox ids into a hidden field. That field is normally a
// Stimulus target, but it often lives outside this controller's element - so
// there is an id fallback, and fieldId names it. The default is the album
// catalog's, which was the only caller when this was written.
export default class extends Controller {
  static targets = ["checkbox", "selectedField"]
  static values = { fieldId: { type: String, default: "album_selected_dsps" } }

  connect() {
    // Update hidden field based on currently checked boxes
    // (boxes are pre-checked by server-side rendering based on selected_dsps)
    this.updateHiddenField()

    // Also update on form submit to ensure we capture the latest state
    const form = this.element.closest('form')
    if (form) {
      form.addEventListener('submit', () => {
        this.updateHiddenField()
      })
    }
  }

  updateSelection(event) {
    this.updateHiddenField()
  }

  updateHiddenField() {
    const selectedIds = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => parseInt(checkbox.value))

    // Try to find the hidden field using Stimulus target first, fallback to ID
    const hiddenField = this.hasSelectedFieldTarget
      ? this.selectedFieldTarget
      : document.getElementById(this.fieldIdValue)

    if (hiddenField) {
      hiddenField.value = JSON.stringify(selectedIds)
    } else {
      console.error(`dsp-selector: hidden field not found (no selectedField target and no #${this.fieldIdValue})`)
    }
  }

  // Only the rows on screen. A DSP hidden because it has no FUGA id must not
  // be swept up by "select all".
  get visibleCheckboxes() {
    return this.checkboxTargets.filter(checkbox => !checkbox.closest(".hidden"))
  }

  selectAll(event) {
    event.preventDefault()
    this.visibleCheckboxes.forEach(checkbox => {
      checkbox.checked = true
    })
    this.updateHiddenField()
    return false
  }

  deselectAll(event) {
    event.preventDefault()
    this.visibleCheckboxes.forEach(checkbox => {
      checkbox.checked = false
    })
    this.updateHiddenField()
    return false
  }
}
